import { RadioButtonField as CssModulesRadioButtonField, RadioButtonFieldProps } from '@sunwebgroup/uds-ui/fields/radio-button-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/radio-button-field' instead.
 */
export default Object.assign(
  styled(CssModulesRadioButtonField)<RadioButtonFieldProps>``,
  { displayName: 'RadioButtonField' },
)
